"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEMsByLead = getEMsByLead;
exports.getEMSuperiors = getEMSuperiors;
exports.getEMSubordinates = getEMSubordinates;
exports.getEMSubordinatesByLead = getEMSubordinatesByLead;
function getEMsByLead(all) {
    return all.reduce((acc, em) => {
        const lead = em.lead || "";
        if (!acc[lead]) {
            acc[lead] = [];
        }
        acc[lead].push(em);
        return acc;
    }, {});
}
function getEMSuperiors(ems, emId) {
    const superiors = new Set();
    let emLeadId = ems[emId]?.lead;
    while (emLeadId) {
        if (emId === emLeadId || superiors.has(emLeadId)) {
            continue;
        }
        superiors.add(emLeadId);
        emLeadId = ems[emLeadId]?.lead;
    }
    return Array.from(superiors).map((id) => ems[id]);
}
function addSubordinate(emsByLead, subordinates, emId) {
    if (subordinates.has(emId)) {
        return;
    }
    subordinates.add(emId);
    (emsByLead[emId] || []).forEach((s) => addSubordinate(emsByLead, subordinates, s.id));
}
function getEMSubordinates(ems, emId) {
    const emsByLead = getEMsByLead(Object.values(ems));
    const subordinates = new Set();
    (emsByLead[emId] || [])
        .filter((em) => em.lead === emId)
        .forEach((s) => addSubordinate(emsByLead, subordinates, s.id));
    return Array.from(subordinates)
        .map((id) => ems[id])
        .sort((a, b) => a.compare(b));
}
function getEMSubordinatesByLead(ems) {
    const emsByLead = getEMsByLead(Object.values(ems));
    return Object.keys(emsByLead).reduce((acc, emId) => {
        acc[emId] = getEMSubordinates(ems, emId);
        return acc;
    }, {});
}
//# sourceMappingURL=EMAggregator.js.map